export var DropSerializer;
(function (DropSerializer) {
    DropSerializer["LIST_VIEW"] = "DROP_LIST_VIEW_SERIALIZER";
})(DropSerializer || (DropSerializer = {}));
export var TargetedOutreachGroup;
(function (TargetedOutreachGroup) {
    TargetedOutreachGroup["All"] = "all";
    TargetedOutreachGroup["Points"] = "points";
    TargetedOutreachGroup["DropParticipants"] = "dropParticipants";
    TargetedOutreachGroup["EligibleCreators"] = "eligibleCreators";
})(TargetedOutreachGroup || (TargetedOutreachGroup = {}));
export const targetedOutreachCreatorKey = 'targetedOutreachCreator';
export const outreachEligibleMinCcv = 10;
export const dropEndpointIds = {
    ON_COMPLETED_DROP: 'ON_COMPLETED_DROP',
    UNCOMPLETED_PENDING_DROPS: 'UNCOMPLETED_PENDING_DROPS',
    UNCOMPLETED_DROP_DARES_REMINDER: 'UNCOMPLETED_DROP_DARES_REMINDER',
    DROP_GET_EVENT: 'DROP_GET_EVENT',
    GET_DROP_MEDIA: 'GET_DROP_MEDIA',
    GET_DROP_WATCH_TIME_PREDICTION: 'GET_DROP_WATCH_TIME_PREDICTION',
    SET_EMAIL_SUBSCRIPTION_DROP: 'SET_EMAIL_SUBSCRIPTION_DROP',
    GET_USER_CAMPAIGN_DATA: 'GET_USER_CAMPAIGN_DATA',
    TRAIN_DROP_WATCH_TIME_PREDICTION: 'TRAIN_DROP_WATCH_TIME_PREDICTION',
    GET_DROP_STATISTICS: 'GET_DROP_STATISTICS',
    UPDATE_DROP_MNEMONIC_ID: 'UPDATE_DROP_MNEMONIC_ID',
    GET_DROP_SIMILARITY_SCORE_BY_RATIO: 'GET_DROP_SIMILARITY_SCORE_BY_RATIO',
    CHECK_TARGETED_DROP_OUTREACH: 'CHECK_TARGETED_DROP_OUTREACH',
    SEND_TARGETED_DROP_OUTREACH: 'SEND_TARGETED_DROP_OUTREACH',
    SEND_TARGETED_DROP_OUTREACH_TASK: 'SEND_TARGETED_DROP_OUTREACH_TASK',
    GET_TARGETED_DROP_OUTREACH_CREATORS: 'GET_TARGETED_DROP_OUTREACH_CREATORS',
    GET_DROP_LANDING_SHORT_URLS: 'GET_DROP_LANDING_SHORT_URLS',
    CREATE_DROP_LANDING_SHORT_URL: 'CREATE_DROP_LANDING_SHORT_URL',
};
